import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class ResearchCost extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '研发费用情况';
    }
    
    getColumns = () => {
        return [{
            title: '',
            dataIndex: 'year'
        }, {
            title: '研发费用支出',
            dataIndex: 'deveexpe'
        }, {
            title: '占营业收入比例',
            dataIndex: 'percent'
        }, {
            title: '行业研发费用占收入比例占比均值',
            dataIndex: 'avgPercent'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/ResearchCost.jsx